<template>
  <div id='client-tab'>
    <div class='tabs'>
      <div class="d-flex justify-content-around">
        <div
          class="tab"
          :class="{ active: tab === cacheValue }"
          :key="index"
          v-for="(tab, index) in tabs"
          @click="clickTab(tab)"
        >
          {{ $t(tab) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import TAB_NAMES from '../TabComponents/tabs';

const { useState: useStateApp } = createNamespacedHelpers('app');

export default {
  name: 'client-tab',
  props: {
    value: {
      type: String,
      default: 'NOTES'
    },
  },
  setup(props, { emit }) {
    const { isDesktop } = useStateApp(['isDesktop']);

    const tabs = computed(() => Object.values(TAB_NAMES).reduce((tabList, tabItem) => {
      if (isDesktop.value && tabItem !== TAB_NAMES.CLIENT_INFO) {
        tabList.push(tabItem);
      } else if (!isDesktop.value) {
        tabList.push(tabItem);
      }
      return tabList;
    }, []));

    const cacheValue = ref(props.value);

    const clickTab = (value) => { cacheValue.value = value; };

    watch(cacheValue, () => emit('input', cacheValue.value));

    return {
      tabs,
      cacheValue,
      clickTab,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#client-tab {

  .tabs {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-color: $iron;

    .tab {
      text-transform: uppercase;
      font-weight: bold;
      cursor: pointer;
      font-size: 14px;
      color: $independence;
      padding: 20px 15px;
      transition: all .2s ease-in-out;

      &.active {
        color: $paradisePink;
      }

      &.disabled {
        color: $lavenderGrey;
        pointer-events: none;
      }
    }
  }

  @media (max-width: 991px) {
    border-radius: 0px;
    background-color: $iron;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .tabs {
      .active {
        border-bottom: unset;
        background-color: $babyPowder;
        box-shadow: inset 0px 2px 0px $paradisePink;
      }
    }
  }

  @media (max-width: 575px) {
    display: flex;
    .tabs {
      .tab {
        font-size: 13px;
      }
    }
  }
}
</style>
